const $$splitComponentImporter = () => import('/app/frontend/src/routes/_anon/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { safeRedirect } from '@/features/auth/model/safe-redirect';

/** Fallback backdrop until a screen declares its own via `staticData`. */

/** Search shared by the anon screens: where to return after a successful login. */

/**
 * Public layout group (login, and later forgot/update password). Bare centered
 * shell — no sidebar. An already-authenticated visitor is bounced to their
 * intended destination (`?redirect=`, sanitized) or the app root.
 */
export const Route = createFileRoute('/_anon')({
  validateSearch: (search: Record<string, unknown>): AnonSearch => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined
  }),
  beforeLoad: ({
    context,
    search
  }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({
        href: safeRedirect(search.redirect)
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});